import React, { useContext, useState, useEffect } from "react";
import { Store } from "../Store";
import { AppBar, Toolbar, Box, Typography, Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const Header = () => {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  const signoutHandler = () => {
    ctxDispatch({ type: "USER_SIGNOUT" });
    localStorage.removeItem("userInfo");
    window.location.href = "/login";
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [categories, setCategories] = useState();

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getCategories = async () => {
    const res = await axios
      .get("https://api.aghayev-marjanscy.pl/api/projects/categories")
      .catch((err) => console.log(err));
    const data = await res.data;
    return data;
  };

  useEffect(() => {
    getCategories().then((data) => setCategories(data.categories));
  }, []);

  return (
    <Toolbar
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: 80,
      }}
    >
      <Link to="/" style={{ textDecoration: "none" }}>
        <Box
          component="img"
          src="/logo_final.svg"
          alt="Marjanscy"
          sx={{
            height: 80,
            display: "block",
          }}
        />
      </Link>

      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ width: 150, justifyContent: "flex-end" }}
      >
        {userInfo && userInfo.isAdmin && (
          <Link to="/projects/add" style={{ textDecoration: "none" }}>
            <Button sx={{ color: "#000" }}>Dodaj Projekt</Button>
          </Link>
        )}

        {!userInfo && (
          <Link to="/login" style={{ textDecoration: "none", color: "black" }}>
            <Typography variant="h6" color="white">Z</Typography>
          </Link>
        )}

        {userInfo && (
          <Button onClick={signoutHandler} sx={{ color: "#000" }}>
            Wyloguj
          </Button>
        )}

        <Button onClick={handleClick} sx={{ color: "#000" }}>
          Projekty
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <Link to="/" style={{ textDecoration: "none", color: "black" }}>
            <MenuItem onClick={handleClose}>Wszystkie</MenuItem>
          </Link>

          {categories &&
            categories.map((category) => (
              <Link
                to={`/search?category=${category}`}
                style={{ textDecoration: "none", color: "black" }}
                key={category}
              >
                <MenuItem onClick={handleClose}>{category}</MenuItem>
              </Link>
            ))}
        </Menu>

        <Link to="/aboutus" style={{ textDecoration: "none" }}>
          <Button sx={{ color: "#000" }}>O nas</Button>
        </Link>

        <Link to="/contact" style={{ textDecoration: "none" }}>
          <Button sx={{ color: "#000" }}>Kontakt</Button>
        </Link>
      </Stack>
    </Toolbar>
  );
};

export default Header;
